(() => {
  const playPanelVideo = (panel) => {
    if (!panel) return;

    const hosted = panel.querySelector('[data-pilates-guided-video]');
    const iframe = panel.querySelector('[data-pilates-guided-video-iframe]');

    if (hosted) {
      hosted.muted = true;
      hosted.loop = true;
      const playPromise = hosted.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
      return;
    }

    if (!iframe) return;

    const provider = iframe.dataset.pilatesVideoProvider;
    if (provider === 'youtube') {
      const id = iframe.dataset.pilatesYoutubeId;
      iframe.src = `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&playsinline=1&iv_load_policy=3&disablekb=1&rel=0&modestbranding=1`;
    } else if (provider === 'vimeo') {
      const id = iframe.dataset.pilatesVimeoId;
      iframe.src = `https://player.vimeo.com/video/${id}?background=1&autoplay=1&loop=1&muted=1&controls=0`;
    }
  };

  const pausePanelVideo = (panel, { reset = true } = {}) => {
    if (!panel) return;

    const hosted = panel.querySelector('[data-pilates-guided-video]');
    const iframe = panel.querySelector('[data-pilates-guided-video-iframe]');

    if (hosted) {
      hosted.pause();
      if (reset) hosted.currentTime = 0;
      return;
    }

    if (iframe) {
      iframe.removeAttribute('src');
    }
  };

  const setPlayButtonState = (playBtn, playing) => {
    if (!playBtn) return;

    const playIcon = playBtn.querySelector('.pilates-hero__play-icon--play');
    const pauseIcon = playBtn.querySelector('.pilates-hero__play-icon--pause');
    const playLabel = playBtn.dataset.labelPlay || 'Play video';
    const pauseLabel = playBtn.dataset.labelPause || 'Pause video';

    if (playIcon) playIcon.hidden = playing;
    if (pauseIcon) pauseIcon.hidden = !playing;
    playBtn.setAttribute('aria-label', playing ? pauseLabel : playLabel);
    playBtn.setAttribute('aria-pressed', playing ? 'true' : 'false');
  };

  const initMovementCarousel = (root) => {
    const carousel = root.querySelector('.pilates-guided__movement-carousel');
    const track = root.querySelector('[data-pilates-guided-movement-track]');
    const viewport = root.querySelector('[data-pilates-guided-movement-viewport]');
    const originalSlides = Array.from(root.querySelectorAll('[data-pilates-guided-movement]'));

    if (!track || !viewport || originalSlides.length < 2) return;

    const isMobile = window.matchMedia('(max-width: 1024px)').matches;
    const getScrollSpeed = (key, fallback = 64) => {
      const value = parseFloat(carousel?.dataset[key] || '');
      return Number.isFinite(value) && value > 0 ? value : fallback;
    };

    if (isMobile) {
      const mobileSpeedPxPerSec = getScrollSpeed('scrollSpeedMobile');
      viewport.classList.add('is-mobile-marquee');
      track.style.transform = '';
      track.style.transition = 'none';

      const rowsWrapper = document.createElement('div');
      rowsWrapper.className = 'pilates-guided__movement-mobile-rows';

      const loopedTenSlides = Array.from({ length: 10 }, (_, i) => {
        const source = originalSlides[i % originalSlides.length];
        return source.cloneNode(true);
      });

      const createRow = (sourceSlides, { reverse = false } = {}) => {
        const row = document.createElement('div');
        row.className = 'pilates-guided__movement-mobile-row';

        const rowTrack = document.createElement('div');
        rowTrack.className = 'pilates-guided__movement-mobile-track';

        const firstSet = sourceSlides.map((slide) => {
          const clone = slide.cloneNode(true);
          clone.classList.add('is-active');
          return clone;
        });
        const secondSet = sourceSlides.map((slide) => {
          const clone = slide.cloneNode(true);
          clone.classList.add('is-active');
          return clone;
        });

        firstSet.forEach((slide) => rowTrack.appendChild(slide));
        secondSet.forEach((slide) => rowTrack.appendChild(slide));
        row.appendChild(rowTrack);

        return {
          track: rowTrack,
          firstSlide: firstSet[0],
          firstCloneSlide: secondSet[0],
          speed: mobileSpeedPxPerSec,
          reverse,
          offset: 0,
          cycleWidth: 0,
        };
      };

      const rowOneSlides = loopedTenSlides.slice(0, 5);
      const rowTwoSlides = loopedTenSlides.slice(5, 10);
      const rowStates = [createRow(rowOneSlides), createRow(rowTwoSlides, { reverse: true })];
      rowStates.forEach((rowState) => rowsWrapper.appendChild(rowState.track.parentElement));
      viewport.appendChild(rowsWrapper);

      let rafId = null;
      let lastTs = 0;
      let paused = false;

      const applyRowTransform = (rowState) => {
        const x = rowState.reverse ? -rowState.cycleWidth + rowState.offset : -rowState.offset;
        rowState.track.style.transform = `translate3d(${x}px, 0, 0)`;
      };

      const measureRows = () => {
        rowStates.forEach((rowState) => {
          rowState.cycleWidth = rowState.firstCloneSlide.offsetLeft - rowState.firstSlide.offsetLeft;
          if (rowState.cycleWidth <= 0) return;
          rowState.offset = ((rowState.offset % rowState.cycleWidth) + rowState.cycleWidth) % rowState.cycleWidth;
          applyRowTransform(rowState);
        });
      };

      const tick = (ts) => {
        if (!lastTs) lastTs = ts;
        const dt = (ts - lastTs) / 1000;
        lastTs = ts;

        if (!paused) {
          rowStates.forEach((rowState) => {
            if (rowState.cycleWidth <= 0) return;
            rowState.offset += rowState.speed * dt;
            if (rowState.offset >= rowState.cycleWidth) {
              rowState.offset -= rowState.cycleWidth;
            }
            applyRowTransform(rowState);
          });
        }

        rafId = window.requestAnimationFrame(tick);
      };

      const pause = () => {
        paused = true;
      };
      const resume = () => {
        paused = false;
      };

      viewport.addEventListener('mouseenter', pause);
      viewport.addEventListener('mouseleave', resume);
      viewport.addEventListener('focusin', pause);
      viewport.addEventListener('focusout', resume);

      rowStates.forEach((rowState) => {
        rowState.track.querySelectorAll('img').forEach((img) => {
          if (img.complete) return;
          img.addEventListener('load', measureRows, { once: true });
        });
      });

      let resizeTimer;
      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(measureRows, 120);
      });

      document.addEventListener(
        'visibilitychange',
        () => {
          if (document.hidden) {
            paused = true;
            return;
          }
          paused = false;
          lastTs = 0;
        },
        { passive: true }
      );

      measureRows();
      rafId = window.requestAnimationFrame(tick);

      const observer = new MutationObserver(() => {
        if (document.body.contains(root)) return;
        if (rafId) window.cancelAnimationFrame(rafId);
        observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      return;
    }

    const cloneSlides = originalSlides.map((slide) => slide.cloneNode(true));
    cloneSlides.forEach((slide) => {
      slide.classList.add('is-active');
      track.appendChild(slide);
    });

    const slides = Array.from(track.querySelectorAll('[data-pilates-guided-movement]'));
    slides.forEach((slide) => slide.classList.add('is-active'));

    let cycleWidth = 0;
    let offsetX = 0;
    let rafId = null;
    let lastTs = 0;
    let isPaused = false;
    const speedPxPerSec = getScrollSpeed('scrollSpeedDesktop');

    const measure = () => {
      const firstOriginal = originalSlides[0];
      const firstClone = cloneSlides[0];
      if (!firstOriginal || !firstClone) return;
      cycleWidth = firstClone.offsetLeft - firstOriginal.offsetLeft;
      if (cycleWidth <= 0) return;

      if (!track.dataset.autoInitDone) {
        const parsedDefault = parseInt(carousel?.dataset.defaultActiveIndex ?? '', 10);
        let defaultIndex = Number.isFinite(parsedDefault) ? parsedDefault : Math.floor((originalSlides.length - 1) / 2);
        defaultIndex = Math.max(0, Math.min(defaultIndex, originalSlides.length - 1));

        const defaultSlide = originalSlides[defaultIndex];
        const viewportCenter = viewport.clientWidth / 2;
        const defaultCenter = defaultSlide.offsetLeft + defaultSlide.offsetWidth / 2;
        offsetX = defaultCenter - viewportCenter;
        track.dataset.autoInitDone = 'true';
      }

      offsetX = ((offsetX % cycleWidth) + cycleWidth) % cycleWidth;
      track.style.transform = `translate3d(${-offsetX}px, 0, 0)`;
    };

    const tick = (ts) => {
      if (!lastTs) lastTs = ts;
      const dt = (ts - lastTs) / 1000;
      lastTs = ts;

      if (!isPaused && cycleWidth > 0) {
        offsetX += speedPxPerSec * dt;
        if (offsetX >= cycleWidth) {
          offsetX -= cycleWidth;
        }
        track.style.transform = `translate3d(${-offsetX}px, 0, 0)`;
      }

      rafId = window.requestAnimationFrame(tick);
    };

    track.style.transition = 'none';
    measure();

    slides.forEach((slide) => {
      slide.querySelectorAll('img').forEach((img) => {
        if (img.complete) return;
        img.addEventListener('load', measure, { once: true });
      });
    });

    const pause = () => {
      isPaused = true;
    };
    const resume = () => {
      isPaused = false;
    };

    viewport.addEventListener('mouseenter', pause);
    viewport.addEventListener('mouseleave', resume);
    viewport.addEventListener('focusin', pause);
    viewport.addEventListener('focusout', resume);

    let resizeTimer;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(measure, 120);
    });

    rafId = window.requestAnimationFrame(tick);

    document.addEventListener(
      'visibilitychange',
      () => {
        if (document.hidden) {
          isPaused = true;
          return;
        }
        isPaused = false;
        lastTs = 0;
      },
      { passive: true }
    );

    // Keep the animation loop clean if the section is removed dynamically.
    const observer = new MutationObserver(() => {
      if (document.body.contains(root)) return;
      if (rafId) window.cancelAnimationFrame(rafId);
      observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  const initGuided = (root) => {
    const tabs = Array.from(root.querySelectorAll('[data-pilates-guided-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-pilates-guided-panel]'));
    const playBtn = root.querySelector('[data-pilates-guided-play]');
    const media = root.querySelector('.pilates-guided__media');
    const classesWrap = root.querySelector('.pilates-guided__classes');
    const movements = root.querySelector('.pilates-guided__movements');
    const mobileQuery = window.matchMedia('(max-width: 1024px)');
    const mediaPlaceholder = document.createElement('div');
    mediaPlaceholder.className = 'pilates-guided__media-placeholder';
    if (media && classesWrap) {
      classesWrap.insertBefore(mediaPlaceholder, media.nextSibling);
    }
    let isPlaying = false;
    let activeIndex = tabs.findIndex((tab) => tab.classList.contains('is-active'));
    if (activeIndex < 0) activeIndex = 0;

    const getActivePanel = () => panels[activeIndex];

    const setFloatingMedia = (enabled, topOffset = 20) => {
      if (!media) return;
      if (!enabled) {
        media.classList.remove('is-mobile-playing-fixed');
        media.style.removeProperty('--guided-media-top');
        media.style.removeProperty('--guided-media-left');
        media.style.removeProperty('--guided-media-width');
        mediaPlaceholder.style.height = '';
        return;
      }

      const rect = media.getBoundingClientRect();
      const fallbackWidth = media.parentElement ? media.parentElement.getBoundingClientRect().width : 0;
      const computedWidth = Math.max(rect.width || 0, media.offsetWidth || 0, fallbackWidth || 0);
      if (computedWidth <= 0) return;

      media.classList.add('is-mobile-playing-fixed');
      media.style.setProperty('--guided-media-top', `${topOffset}px`);
      media.style.setProperty('--guided-media-left', `${rect.left}px`);
      media.style.setProperty('--guided-media-width', `${computedWidth}px`);
      mediaPlaceholder.style.height = `${rect.height}px`;
    };

    const syncFloatingMedia = () => {
      if (!media || !classesWrap) return;
      if (!mobileQuery.matches || !isPlaying) {
        setFloatingMedia(false);
        return;
      }

      const stickyNav = document.querySelector('.pilates-hero__nav.is-fixed') || document.querySelector('.pilates-hero__nav');
      const navHeight = stickyNav ? stickyNav.getBoundingClientRect().height : 0;
      const stickTop = Math.round(navHeight + 20);
      const placeholderRect = mediaPlaceholder.getBoundingClientRect();
      const mediaHeight = media.offsetHeight || placeholderRect.height;
      const movementsRect = movements ? movements.getBoundingClientRect() : null;

      const scrolledPastMedia = placeholderRect.top <= stickTop;
      const reachedMovements = movementsRect
        ? movementsRect.top <= stickTop + mediaHeight
        : false;
      const shouldStick = scrolledPastMedia && !reachedMovements;

      setFloatingMedia(shouldStick, stickTop);
    };

    const syncActivePanelVideo = () => {
      const panel = getActivePanel();
      if (!panel) return;

      if (isPlaying) {
        playPanelVideo(panel);
      } else {
        pausePanelVideo(panel, { reset: false });
      }

      setPlayButtonState(playBtn, isPlaying);
      syncFloatingMedia();
    };

    if (tabs.length > 0) {
      const setActive = (index) => {
        const previousPanel = panels[activeIndex];
        activeIndex = index;

        tabs.forEach((tab, i) => {
          const isActive = i === index;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((panel, i) => {
          const isActive = i === index;
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        if (previousPanel && previousPanel !== panels[index]) {
          pausePanelVideo(previousPanel);
        }

        syncActivePanelVideo();
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const index = parseInt(tab.dataset.index, 10);
          if (!Number.isFinite(index) || index === activeIndex) return;
          setActive(index);

          if (window.PilatesAnalytics && typeof window.PilatesAnalytics.pushLearnMore === 'function') {
            const titleEl = tab.querySelector('.pilates-guided__class-title');
            const params = {
              itemName: titleEl ? titleEl.textContent.trim() : '',
              section: 'section_guided_classes',
            };
            window.PilatesAnalytics.pushLearnMore(params);
          }
        });
      });

      setActive(activeIndex);
    }

    if (playBtn) {
      playBtn.addEventListener('click', () => {
        const panel = getActivePanel();
        if (!panel) return;

        isPlaying = !isPlaying;

        if (isPlaying) {
          playPanelVideo(panel);
        } else {
          pausePanelVideo(panel, { reset: false });
        }

        setPlayButtonState(playBtn, isPlaying);
        syncFloatingMedia();
      });
    }

    window.addEventListener('scroll', syncFloatingMedia, { passive: true });
    window.addEventListener('resize', syncFloatingMedia);
    mobileQuery.addEventListener('change', syncFloatingMedia);

    initMovementCarousel(root);
  };

  document.querySelectorAll('[data-pilates-guided]').forEach(initGuided);
})();
